import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/Formatters';
import Routes from 'utils/routes.js.erb';
import { AUTH_TOKEN } from '../../actions';

const isReportPending = (report) => {
  return (report.status === 'pending' ||
    report.status === 'in_progress');
}

const isReportFailed = (report) => {
  return report.status === 'failed';
}

const ReportDownload = ({ report }) => {
  const { t } = useTranslation();
  const currentReport = report.previous || report;

  if (currentReport && isReportPending(currentReport)) {
    return (
      <div className='o-report-status'>
        <i className='fa o-spinner-dual'></i>
        <span>{t('reportDownload.pending', { date: formatDateTime(currentReport.createdAt) })}</span>
      </div>
    );
  }

  if (currentReport && isReportFailed(currentReport)) {
    return (
      <div className='o-report-status o-report-status--error'>
        <i className='fa fa-exclamation-triangle'></i>
        <span>{t('reportDownload.failed')}</span>
      </div>
    );
  }

  if (currentReport && currentReport.presignedS3Url) {
    return (
      <a className='o-report-status' href={currentReport.presignedS3Url} download onClick={() => {
        fetch(Routes.api_dashboard_partner_actions_path(), {
          method: 'POST',
          headers: {
            'Authorization': window.auth_session_token || localStorage.getItem(AUTH_TOKEN),
            'JWTAUD': 'dashboard',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ report_id: currentReport.id }),
        })
      }}>
        <i className='fa fa-download'></i>
        <span>{t('reportDownload.pending', { date: formatDateTime(currentReport.createdAt) })}</span>
      </a>
    );
  }

  return null;
};

ReportDownload.propTypes = {
  report: PropTypes.object,
  onReportDetailsShow: PropTypes.func,
}

export default ReportDownload;
